import { render, staticRenderFns } from "./DAuthHeaderLanguageMenu.vue?vue&type=template&id=12b39170&scoped=true&"
import script from "./DAuthHeaderLanguageMenu.vue?vue&type=script&lang=js&"
export * from "./DAuthHeaderLanguageMenu.vue?vue&type=script&lang=js&"
import style0 from "./DAuthHeaderLanguageMenu.vue?vue&type=style&index=0&id=12b39170&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b39170",
  null
  
)

export default component.exports